<template>
    <div>
        <nav class="navbar navbar-expand-md navbar-dark fixed-top py-0">
            <button class="navbar-toggler border-none mx-3 mb-2 mt-1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <img src="@/assets/img/logo.svg" width="150" class="mx-3 mb-2 mt-1" alt="Logo" />
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li v-if="showBookings" class="nav-item dropdown no-arrow" :class="{'bold': bookingsActive}">
                        <a class="nav-link dropdown-toggle" id="dropdownBookings" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="mr-2  d-lg-inline">
                                Bookings
                            </span>
                        </a>
                        <div class="dropdown-menu" aria-labelledby="dropdownBookings">
                            <li v-if="canSee('FIT')" :class="{'bold': $route.name == 'FIT'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'FIT'})">
                                    FIT
                                </a>
                            </li>
                            <li v-if="canSee('GROUPS')" :class="{'bold': $route.name == 'GROUPS'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'GROUPS'})">
                                    GROUPS
                                </a>
                            </li>
                            <li v-if="canSee('PCM')" :class="{'bold': $route.name == 'PCM'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'PCM'})">
                                    PCM
                                </a>
                            </li>
                        </div>
                    </li>
                    <li v-if="showConfigsBooking" class="nav-item dropdown no-arrow" :class="{'bold': configsBookingActive}">
                        <a class="nav-link dropdown-toggle" id="dropdownConfigsBooking" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="mr-2  d-lg-inline">
                                Configs Booking
                            </span>
                        </a>
                        <div class="dropdown-menu" aria-labelledby="dropdownConfigsBooking">
                            <li v-if="canSee('users')" :class="{'bold': $route.name == 'users'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'users'})">
                                    Users
                                </a>
                            </li>
                            <li v-if="canSee('accessgroups')" :class="{'bold': $route.name == 'accessgroups'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'accessgroups'})">
                                    Access Groups
                                </a>
                            </li>
                            <li v-if="canSee('languages')" :class="{'bold': $route.name == 'languages'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'languages'})">
                                    Languages
                                </a>
                            </li>
                            <li v-if="canSee('groupterms')" :class="{'bold': $route.name == 'groupterms'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'groupterms'})">
                                    Group Terms
                                </a>
                            </li>
                            <li v-if="canSee('image_update')" :class="{'bold': $route.name == 'image_update'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'image_update'})">
                                    Image Update
                                </a>
                            </li>
                            <li v-if="canSee('trees')" :class="{'bold': $route.name == 'trees'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'trees'})">
                                    Trees
                                </a>
                            </li>
                            <li v-if="canSee('bookingexpireddefault')" :class="{'bold': $route.name == 'bookingexpireddefault'}">
                                <a class="dropdown-item cursor-pointer" @click="$router.push({name: 'bookingexpireddefault'})">
                                    Vencimiento por Defecto
                                </a>
                            </li>
                        </div>
                    </li>
                    <li v-if="canSee('bookingforms')" class="nav-item" :class="{'bold': $route.name == 'bookingforms'}">
                        <a class="nav-link" @click="$router.push({name: 'bookingforms'})" >
                            <span class="mr-2  d-lg-inline">
                                Booking Forms
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('sales')" class="nav-item" :class="{'bold': $route.name == 'sales'}">
                        <a class="nav-link" @click="$router.push({name: 'sales'})" >
                            <span class="mr-2  d-lg-inline">
                                Sales
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('bookingccs')" class="nav-item" :class="{'bold': $route.name == 'bookingccs'}">
                        <a class="nav-link" @click="$router.push({name: 'bookingccs'})" >
                            <span class="mr-2  d-lg-inline">
                                Currency Rates
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('bookingexpireds')" class="nav-item" :class="{'bold': $route.name == 'bookingexpireds'}">
                        <a class="nav-link" @click="$router.push({name: 'bookingexpireds'})" >
                            <span class="mr-2  d-lg-inline">
                                Booking Expired
                            </span>
                        </a>
                    </li>

                </ul>

                <ul class="navbar-nav ml-auto">
                    <li class="nav-item dropdown no-arrow">
                        <a v-if="user" class="nav-link dropdown-toggle" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="mr-2 d-lg-inline"> {{ user.UserName }} </span>
                            <img class="img-profile rounded-circle" :src="user.Image.url" v-if="user.ImageId">
                        </a>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <li><a class="dropdown-item cursor-pointer" @click="$router.push({name: 'userProfile'})">
                                <!--font-awesome-icon icon="user" class="fa-sm fa-fw mr-2 text-gray-400"/-->
                                Profile
                            </a></li>
                            <div class="dropdown-divider"></div>
                            <li><a class="dropdown-item cursor-pointer" @click="$router.push({name: 'Logout'})">
                                <!--font-awesome-icon icon="sign-out-alt" class="fa-sm fa-fw mr-2 text-gray-400"/-->
                                Sign out
                            </a></li>
                        </div>
                    </li>            
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'NavBar',
    data () {
        return {
            collapse: false,
        };
    },
    computed: {
        user () {
            return this.$store.state.user;
        },
        menuPermissions () {
            const ag = this.user && this.user.AccessGroup;
            if (!ag) return {};
            return (ag.permissionsMerge && ag.permissionsMerge.menu)
                || (ag.permissions && ag.permissions.menu)
                || {};
        },
        showBookings () {
            return ['FIT', 'GROUPS', 'PCM'].some(name => this.canSee(name));
        },
        showConfigsBooking () {
            return ['users', 'accessgroups', 'languages', 'groupterms', 'image_update', 'trees', 'bookingexpireddefault']
                .some(name => this.canSee(name));
        },
        bookingsActive () {
            return ['FIT', 'GROUPS', 'PCM'].includes(this.$route.name);
        },
        configsBookingActive () {
            return ['users', 'accessgroups', 'languages', 'groupterms', 'image_update', 'trees', 'bookingexpireddefault']
                .includes(this.$route.name);
        }
    },
    async mounted () {
    },
    methods: {
        canSee (routeName) {
            return this.menuPermissions[routeName] !== false;
        },
        logout () {
            this.$router.push({name: 'Logout'});
        },
        setRoute (tableName) {
            this.$router.push({ name: 'abm', params: { table: tableName }});
        }
    },
};
</script>

<style scoped>
.dropdown-toggle, .dropdown-toggle:hover, .d-lg-inline {
    color: white;
}
.navbar-collapse {
    background-color: #3283e7;
}
.bold a span {
    font-weight: bold;
    color: #c4c4c4;
}
</style>
